import { render, staticRenderFns } from "./OverallTab.vue?vue&type=template&id=6a6d040c&scoped=true&"
import script from "./OverallTab.vue?vue&type=script&lang=js&"
export * from "./OverallTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6d040c",
  null
  
)

export default component.exports